var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayfab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 6.52678L11.9679 1L21.5 6.52678V17.3875L12.075 23L6.99831 20.0438V14.8384L2.5 12.3749V6.52678ZM11.9679 3.89192L4.92052 7.91918V10.9182L6.99831 12.1392V9.11879L11.9679 6.11977L17.066 9.11879V14.8384L11.9679 17.8374L9.44025 16.3165V18.5657L12.075 20.0438L19.0152 15.9951V7.91918L11.9679 3.89192ZM11.9679 9.11879L9.44025 10.5112V13.4031L11.9679 14.8384L14.5169 13.4031V10.5112L11.9679 9.11879Z",
    fill: "#4B5873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayfab);
export default __webpack_public_path__ + "static/media/playfab.1913e5021c0a5bb8ea00f1531246caac.svg";
export { ForwardRef as ReactComponent };